/*
 * Created By sswaminathan
 * Created on Tue Nov 16 2021
 * Created on SubscriptionManagement.js
 * Copyright (c) 2021  ©Palo Alto Networks
 */


import { LoadingPage } from '@panwds/react-ui'
import { groupBy } from 'lodash'
/**
 *  SubscriptionManagement aggregates the components of the
 *  subscriptions management
 **/
import { useCallback, useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { GetLicenseDetails, GetValidation } from '../../../common/actions/GlobalActions'
import MessageBanner from '../../../common/banner/MessageBanner'
import {
  APP_ID_BACKBONE,
  APP_ID_PRISMA_ACCESS_EDITION,
  APP_ID_SDWAN,
  VIEW_MANAGE_TENANT
} from '../../../common/constants/GlobalConstants'
import { selectTreeNode } from '../../../common/reducers/actions/TreeReducer.actions'
import { findParentRootNode } from '../../../common/reducers/TreeReducer'
import { FF_ENABLE_BACKBONE } from '../../../common/utils/FeatureFlags'
import { getVarValue, loadTsgInstances, setCurrentViewing } from '../../../common/utils/Sparky'
import { ROOT_NODE_ID } from '../../../tenancy/constants/TenancyConstants'
import './subscriptionManagement.scss'
import {
  FULL_ALLOCATION,
  SUBSCRIPTION_ACTION_EDIT, VALIDATION_ALERT_CONTENT,
} from '../constants/SubscriptionConstant'
import Terms from '../EnterpriseActivation/components/Terms'
import LicenseProductContainer from '../licenseProducts/LicenseProductContainer'
import LicenseProductHeader from '../licenseProducts/LicenseProductHeader'


const SubscriptionManagement = (rest) => {
  const { selectedTreeNode, updateProductInformation, globalTsgId,
    licenseInfo, instancesKeyBy, licenseAction, sgKeyBy } = rest
  const [licenseDetails, setLicenseDetails] = useState([])
  const [productInformation, setProductInformation] = useState({})
  const [support_account_id, setSupportAccountId] = useState('')
  const [licenseData, setLicenseData] = useState([])
  const [allocation, setAllocation] = useState(true)
  const [licenseValue, setLicenseValue] = useState()
  const [validation, setValidation] = useState({})
  const [appList, setAppList] = useState([])
  const [formLoad, setFormLoad] = useState()
  const [cgxProduct, setCgxProduct] = useState([])
  const [editDisabled, setEditDisabled] = useState({})
  const [validationAppList, setValidationAppList] = useState([])
  const [validationFailure, setValidationFailure] = useState(false)
  const [isBackBoneInstanceAvailable, setBackBoneInstanceAvailable] = useState(false)
  const { setValue } = useFormContext()

  const isBackboneEnabled = getVarValue(FF_ENABLE_BACKBONE, false)

  const formatEditValues = useCallback(async (props) => {
    const { result } = props
    // Retrieve all the APP_ID from the allocated license
    if (licenseInfo[APP_ID_PRISMA_ACCESS_EDITION]) {
      //      const _app_ids = Object.keys(licenseInfo[APP_ID_PRISMA_ACCESS_EDITION]).filter((each) => each !== APP_ID_PRISMA_ACCESS && each !== APP_ID_DSS_ID)
      const _app_ids = Object.keys(groupBy(licenseInfo[APP_ID_PRISMA_ACCESS_EDITION].entitlements, 'app_id'))
      _app_ids.forEach((each) => {
        setEditDisabled((prev) => {
          prev[each] = true
          return { ...prev }
        })
      })
      //TODO:Single Tenant flow doesn't have the license_id in the extra . Added this to over come the Need to remove this and add login in license Table
      const licenseId = (licenseInfo[APP_ID_PRISMA_ACCESS_EDITION].extra.license_id ??
        licenseInfo[APP_ID_PRISMA_ACCESS_EDITION]?.tenant_id)?.replace('_onprem', '')
      const findEditedLicense = result.response.find(each => each.license_id.includes(licenseId))
      if (findEditedLicense) {
        setAllocation(FULL_ALLOCATION.includes(findEditedLicense?.allocation_type))
        const parentRemainKeys = groupBy(findEditedLicense?.parent_remaining, 'app_id')
        const keys = Object.keys(parentRemainKeys)
        setValidationAppList(keys)
        const enableEdit = keys.every(each => _app_ids.includes(each))
        // Enable edit if all the app_id is present in the edit license
        setEditDisabled((prev) => {
          prev[APP_ID_PRISMA_ACCESS_EDITION] = enableEdit
          return { ...prev }
        })
      }
      setLicenseValue(licenseId)
      setAppList(result.products[licenseId] ? result.products[licenseId][0].appList : [])
      setProductInformation(result.products[licenseId] ? result.products[licenseId] : {})
      setSupportAccountId(result.products[licenseId] ? result.products[licenseId][0]?.support_account_id : '')
      const request = {}
      result.products[licenseId]?.forEach((elem) => {
        if (elem.licenseCardInfo.licenseDisplayName !== 'cgx') {
          request.input = elem.validationRequest
        }
      })
      const response = await GetValidation(request, selectedTreeNode.id)
      if (response?.status === 'FAILED') {
        setValidationFailure(true)
      }
      else {
        setValidation((prev) => {
          const preValue = { ...prev }
          preValue[licenseId] = response
          return preValue
        })
      }
    }
    else {
      // to handle stand alone CIE and user trying to claim and allocate  the SDWAN
      const app_ids = Object.keys(licenseInfo)
      app_ids?.length && app_ids.forEach((each) => {
        setEditDisabled((prev) => {
          prev[each] = true
          return { ...prev }
        })
      })

    }
  }, [licenseInfo, selectedTreeNode.id])
  /**
   * UseEffect used to make service calls to load the license validation. setup initial state fro the object.
   */
  // useEffect(() => {
  //   if (validationFailure) {
  //     invokeValidationAlert()
  //   }
  // }, [invokeValidationAlert, validationFailure])
  useEffect(() => {
    //if (!errorMessage) {
    (async () => {
      setFormLoad(true)
      try {
        let isEdit = false
        // To find if the edit has the PAE
        if (licenseAction === SUBSCRIPTION_ACTION_EDIT) {
          const app_ids = Object.keys(licenseInfo)
          isEdit = app_ids.includes(APP_ID_PRISMA_ACCESS_EDITION)
        }
        // To get all the existing claim information for the TSG
        const result = await GetLicenseDetails({
          tsg_id: selectedTreeNode?.id,
          ancestor: selectedTreeNode.parent_id === ROOT_NODE_ID,
          isEdit,
          licenseInfo,
          instance: instancesKeyBy[selectedTreeNode?.id]
        })
        if (isBackboneEnabled) {
          const rootTsg = findParentRootNode(sgKeyBy, selectedTreeNode)
          await loadTsgInstances(rootTsg.id).then(data => setBackBoneInstanceAvailable(!!data?.get(APP_ID_BACKBONE)))
        }
        updateProductInformation(result.response, result.cgxProduct)
        setLicenseData(result)
        if (result?.cgxProduct?.length > 0) {
          setCgxProduct(result.cgxProduct)
        }
        setLicenseDetails(result.contracts)
        setAllocation(true)
        setFormLoad(false)
        if (licenseAction === SUBSCRIPTION_ACTION_EDIT) {
          await formatEditValues({ result })
        }
      }
      catch (err) {
        setFormLoad(false)
      }
    })()
    // }
  }, [selectedTreeNode, updateProductInformation, globalTsgId, licenseAction, licenseInfo, formatEditValues, instancesKeyBy, isBackboneEnabled, sgKeyBy])

  /**
   * UseEffect is used to load and setup initial state for the the Region and contract DropDown
   */
  useEffect(() => {
    // if (!errorMessage) {
    const licenseValue = licenseDetails ? licenseDetails[0] : []
    setLicenseValue(prev => {
      return licenseValue ? licenseValue.id : prev
    })
    setValue('contract_id', licenseValue)
    // }
  }, [setValue, licenseDetails, licenseAction])


  /**
   * Handles product enable or disable functionality
   * @param value
   * @param licenseDisplayName
   * @param licenseValue
   */
  const handleProductSelection = (value, licenseDisplayName, licenseValue) => {
    // setProductSelection((prev) => {
    //   const preValue = { ...prev }
    //   preValue[`${licenseValue}:${licenseDisplayName}`] = value
    //   return preValue
    // })
  }
  /**
   *Handle the Contract DropDown onchange
   * @type {(function(*): Promise<void>)|*}
   */
  const handleOnChange = useCallback(async (change) => {
    const contractId = change.target.value.id
    setProductInformation(licenseData.products[contractId] ? licenseData.products[contractId] : {})
    setSupportAccountId(licenseData.products[contractId] ? licenseData.products[contractId][0]?.support_account_id : '')
    setLicenseValue(contractId)
    setAllocation(true)
    licenseData.products[contractId]?.forEach((elem) => {
      if (elem.allocation && elem.formFieldName) {
        setValue(elem.formFieldName, elem.value ? elem.value : '')
      }
    })
    setAppList(licenseData.products[contractId] ? licenseData.products[contractId][0].appList : [])
    const request = {}
    licenseData.products[contractId]?.forEach((elem) => {
      if (elem.licenseCardInfo.licenseDisplayName !== APP_ID_SDWAN) {
        request.input = elem.validationRequest
      }
    })
    setValidationAppList(Object.keys(groupBy(request.input, 'app_id')))
    if (request.input) {
      const response = await GetValidation(request, selectedTreeNode.id)
      if (response?.status === 'FAILED') {
        setValidationFailure(true)
      }
      setValidation((prev) => {
        const preValue = { ...prev }
        preValue[contractId] = response
        return preValue
      })
    }

  }, [licenseData.products, setValue, selectedTreeNode.id])

  // useEffect(() => {
  //   setValidationResponse(validation)
  // }, [setValidationResponse, validation])

  /**
   * Handles the user allocation change and setup default values
   * @type {(function(*, *): void)|*}
   */
  const handleAllocationOnChange = useCallback((selectedValue, names) => {
    setAllocation(prev => {
      return selectedValue === 'true'
    })
  }, [setAllocation])

  const cancelAllocation = useCallback(() => {
    rest.setActions(undefined)
    rest.dispatch(selectTreeNode(rest.sgKeyBy[selectedTreeNode?.id]))
    setCurrentViewing(VIEW_MANAGE_TENANT)
  }, [rest, selectedTreeNode])


  return (
    <>
      {formLoad ? <LoadingPage/> : <>
        <div className='licenseSelection'>
          {validationFailure && <MessageBanner message={VALIDATION_ALERT_CONTENT} donNotCloseBanner={true}/>}
          <LicenseProductHeader
            {...{ selectedTreeNode,
              licenseValue,
              licenseDetails,
              cgxProduct,
              editDisabled,
              handleOnChange,
              support_account_id,
              appList,
              ...rest }}/>
        </div>
        <div className='productSelection'>
          <LicenseProductContainer
            {...{ productInformation,
              validation,
              cgxProduct,
              licenseValue,
              allocation,
              editDisabled,
              selectedTreeNode,
              handleProductSelection,
              handleAllocationOnChange,
              setValidationAppList,
              validationAppList,
              setValidation,
              isBackBoneInstanceAvailable,
              ...rest }}/>
        </div>
        <div className='footerSection tw-pb-2'>
          <Terms
            onCancel={cancelAllocation}
            mspFlow={true}
            validationFailure={validationFailure}
          />
        </div>
      </>}
    </>
  )
}

export default SubscriptionManagement

